module.exports = __webpack_public_path__ + "img/newPic.09e134b9.png";